__turbopack_context__.v({
  "customButtons": "wzrPKq_customButtons",
  "customSubtitle": "wzrPKq_customSubtitle",
  "customTextStack": "wzrPKq_customTextStack",
  "customTitle": "wzrPKq_customTitle",
});
